/**
 * CustomTable row shape for the Candid Upload tab.
 *
 * @module candidUpload/types/candidUploadTableRow
 */
import { IconCellValue } from "../../../../../components/custom-table/tableCell/cellTypes/IconCell";

/** Row-data keys for the Candid Upload table columns. */
export enum CandidUploadTableKeys {
  /** Formatted write-back `created_at`. */
  UpdatedAt = "updatedAt",
  /** Human-readable write-back `use_case`. */
  Type = "type",
  /** Success/error badge. */
  Status = "status",
  /** Action icon that opens the Candid RPA status modal. */
  View = "view",
}

/**
 * Badge payload consumed by the BADGE table cell type.
 */
export interface CandidUploadStatusBadge {
  /** Visible badge label (e.g. Success, Error). */
  text: string;
  /** Foreground color for the badge text. */
  color: string;
  /** Background fill for the badge. */
  bgColor: string;
}

/**
 * One Candid Upload table row, keyed by {@link CandidUploadTableKeys}.
 */
export interface CandidUploadTableRow {
  [CandidUploadTableKeys.UpdatedAt]: string;
  [CandidUploadTableKeys.Type]: string;
  [CandidUploadTableKeys.Status]: CandidUploadStatusBadge;
  [CandidUploadTableKeys.View]: IconCellValue;
}
